import React, { SyntheticEvent } from "react";
import { NumericFormat, NumericFormatProps } from "react-number-format";
import { TextFieldProps } from "@mui/material/TextField";
import WcTextField from "../WcTextfield/WcTextField";
import InputAdornment from "@mui/material/InputAdornment";

export type WcNumberProps = TextFieldProps & {
  displayType?: any;
  onValue?: any;
  isString?: boolean;
  prefix?: string;
  suffix?: string;
  size?: string;
  allowNegative?: boolean;
  allowLeadingZeros?: boolean;
  min?: number;
  max?: number;
  disabled?: boolean;
};

export const WcNumber = ({
  onValue,
  displayType,
  prefix,
  suffix,
  inputMode,
  isString,
  size = "medium",
  allowNegative = true,
  allowLeadingZeros = true,
  min,
  max,
  disabled = false,
  ...others
}: WcNumberProps) => {
  const endAdornment = () => (suffix ? <InputAdornment position="start">{suffix}</InputAdornment> : null);

  const startAdornment = () => (prefix ? <InputAdornment position="start">{prefix}</InputAdornment> : null);
  return (
    //@ts-ignore
    <NumericFormat
      disabled={disabled}
      customInput={WcTextField}
      decimalSeparator=","
      thousandSeparator="."
      size={size}
      allowNegative={allowNegative}
      allowLeadingZeros={allowLeadingZeros}
      inputMode={inputMode ? inputMode : "decimal"}
      displayType={displayType ? displayType : "input"}
      onFocus={(event) => {
        event.target.select();
      }}
      InputProps={{
        endAdornment: endAdornment(),
        startAdornment: startAdornment(),
      }}
      //@ts-ignore
      {...others}
      onValueChange={(values) => {
        const { formattedValue, value: customValue, floatValue } = values;
        if (onValue && !isString) {
          onValue(floatValue);
        } else onValue(customValue);
      }}
    />
  );
};

export default WcNumber;
